export const MA_TRACK_ORDER_LOADER = {
  desktop: `<div class="cui-container -spacing--top-80 -spacing--bottom-80" style="max-width: 872px; padding: 0 15px; margin: 0 auto;">
  <div class="cui-skeleton-heading -size--large -spacing--bottom-32 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80">
    <div class="cui-skeleton__item" style="width: 100%; height: 168px;"></div>
  </div>
  <div class="cui-skeleton-heading -size--medium -spacing--bottom-32 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
    <div class="cui-skeleton__item" style="width: 100%; height: 70px;"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
    <div class="cui-skeleton__item" style="width: 100%; height: 70px;"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block">
    <div class="cui-skeleton__item" style="width: 100%; height: 70px;"></div>
  </div>
</div>
<div class="cui-skeleton-rectangle -is--block">
  <div class="cui-skeleton__item" style="width: 100%; height: 128px;"></div>
</div>`
};
